module.exports = __webpack_public_path__ + "img/Inventory Management.3eab487c.svg";